import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledContainer = styled('ul', { listStyle: 'none', padding: '0', margin: 0, textAlign: 'center' });

export const StyledInfoItem = styled('li', {
  marginBottom: '$2',
});

export const StyledLabel = styled(Box, {
  fontSize: '$normal',
  fontWeight: '$medium',
});

export const StyledValue = styled(Box, {
  fontSize: '$md',
  fontWeight: '$bold',
});
